import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalCadastroComponent } from '../../../../shared/modal-cadastro/modal-cadastro.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { getErrorMessage, markFormGroupTouched } from '@utils';
import { NotasFiscaisService } from '../../../../services/notas-fiscais.service';
import * as saveAs from 'file-saver';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-margem-por-item-vendido',
  templateUrl: './margem-por-item-vendido.component.html',
  styleUrls: ['./margem-por-item-vendido.component.css']
})
export class MargemPorItemVendidoComponent extends ModalCadastroComponent implements OnInit {

  constructor(
    private notasFiscaisService: NotasFiscaisService) {
    super()
  }

  @ViewChild('modalRelatorio', { static: true }) modalRelatorio;
  impressaoForm: FormGroup;

  ngOnInit() {
    this.impressaoForm = new FormGroup({
      dataInicial: new FormControl(moment().startOf('month').toDate(), [Validators.required]),
      dataFinal: new FormControl(moment().startOf('day').toDate(), [Validators.required]),
      itemId: new FormControl(null),
      numeroNf: new FormControl(null),
      formato: new FormControl('pdf')
    })
  }

  destroyComponent() {
    this.closed.emit();
  }

  show(): void {
    this.modalRelatorio.show();
  }

  validaForm() {
    markFormGroupTouched(this.impressaoForm);
  }

  async submitForm() {
    if (this.impressaoForm.invalid) {
      return;
    }

    try {
      this.loading['imprimindo'] = true;
      const res = await lastValueFrom(this.notasFiscaisService.imprimirMargemPorItemVendido(this.impressaoForm.value));
      const formato = this.impressaoForm.get('formato').value;
      saveAs(res, `relatorio_margem_de_lucro_por_item.${formato}`);

      this.modalRelatorio.hide();
      this.closed.emit();
    } catch (error) {
      Swal("Erro ao emitir o relatório: Margem de Lucro por item vendido", getErrorMessage(error), "error");
      console.error(error);
    } finally {
      this.loading['imprimindo'] = false;
    }
  }
}

